import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = ["onSubmit"]
const _hoisted_2 = {
  key: 0,
  class: "mt-2 border border-gray-400 rounded"
}
const _hoisted_3 = { class: "pt-0 mt-0 text-gray-800" }
const _hoisted_4 = { class: "space-y-2.5" }
const _hoisted_5 = { class: "space-y-2.5" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "space-y-2.5" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("option", {
  class: "capitalize",
  value: "",
  selected: "",
  disabled: ""
}, "Please select a Country", -1)
const _hoisted_10 = ["value"]
const _hoisted_11 = { class: "pb-2" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("option", {
  class: "capitalize",
  value: "",
  selected: "",
  disabled: ""
}, "Please select a Setting", -1)
const _hoisted_13 = ["value"]
const _hoisted_14 = { class: "flex items-center space-x-3" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", null, "to", -1)
const _hoisted_16 = { class: "mb-2 text-sm italic" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_18 = { class: "hidden w-full table-auto md:table" }
const _hoisted_19 = { class: "font-bold text-left border-b-2 border-black divide-x-2 divide-gray-400" }
const _hoisted_20 = {
  scope: "col",
  class: "w-1/4 px-2 py-2 capitalize"
}
const _hoisted_21 = {
  scope: "col",
  class: "w-1/4 px-2 py-2"
}
const _hoisted_22 = {
  scope: "col",
  class: "w-1/4 px-2 py-2"
}
const _hoisted_23 = {
  scope: "col",
  class: "w-1/4 px-2 py-2 capitalize"
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "w-1/4 px-2 py-2"
}, null, -1)
const _hoisted_25 = { class: "w-64 px-2 py-3 capitalize" }
const _hoisted_26 = { class: "w-64 px-2 py-3 capitalize" }
const _hoisted_27 = { class: "w-64 px-2 py-3 capitalize" }
const _hoisted_28 = { class: "w-64 px-2 py-3 capitalize" }
const _hoisted_29 = { class: "mt-1 text-sm italic" }
const _hoisted_30 = { class: "w-64 px-2 py-3 capitalize" }
const _hoisted_31 = ["onClick"]
const _hoisted_32 = { class: "block md:hidden" }
const _hoisted_33 = { class: "w-full px-2 py-3 capitalize" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("label", { class: "mx-1 font-bold" }, "Date", -1)
const _hoisted_35 = { class: "w-full px-2 py-3" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("label", { class: "mx-1 font-bold" }, "Start time", -1)
const _hoisted_37 = { class: "w-full px-2 py-3" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("label", { class: "mx-1 font-bold" }, "End time", -1)
const _hoisted_39 = { class: "w-full px-2 py-3" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("label", { class: "mx-1 font-bold" }, "Timezone", -1)
const _hoisted_41 = { class: "mt-1 text-sm italic" }
const _hoisted_42 = { class: "w-full px-2 py-3 capitalize" }
const _hoisted_43 = ["onClick"]
const _hoisted_44 = { class: "hidden p-4 mt-6 bg-gray-200 rounded md:block" }
const _hoisted_45 = { class: "mt-4" }
const _hoisted_46 = { class: "flex items-center space-x-2" }
const _hoisted_47 = { value: 1 }
const _hoisted_48 = { value: 2 }
const _hoisted_49 = { value: 3 }
const _hoisted_50 = { value: 4 }
const _hoisted_51 = { value: 5 }
const _hoisted_52 = { value: 6 }
const _hoisted_53 = { value: 0 }
const _hoisted_54 = { class: "inline w-32" }
const _hoisted_55 = { class: "w-32" }
const _hoisted_56 = { class: "p-4 mt-6 bg-gray-200 rounded md:hidden" }
const _hoisted_57 = { class: "mt-4" }
const _hoisted_58 = { class: "flex flex-wrap items-center space-y-2 md:flex-nowrap md:space-x-2 md:space-y-0" }
const _hoisted_59 = { class: "flex flex-wrap items-center w-full space-y-2 md:flex-nowrap md:space-x-2 md:space-y-0" }
const _hoisted_60 = { class: "flex flex-wrap items-center w-full space-y-2 md:flex-nowrap md:space-x-2 md:space-y-0" }
const _hoisted_61 = { value: 1 }
const _hoisted_62 = { value: 2 }
const _hoisted_63 = { value: 3 }
const _hoisted_64 = { value: 4 }
const _hoisted_65 = { value: 5 }
const _hoisted_66 = { value: 6 }
const _hoisted_67 = { value: 0 }
const _hoisted_68 = { class: "flex flex-wrap items-center w-full space-y-2 md:flex-nowrap md:space-x-2 md:space-y-0" }
const _hoisted_69 = { class: "w-full md:w-32" }
const _hoisted_70 = { class: "flex flex-wrap items-center w-full space-y-2 md:flex-nowrap md:space-x-2 md:space-y-0" }
const _hoisted_71 = /*#__PURE__*/_createElementVNode("span", null, "and", -1)
const _hoisted_72 = { class: "w-full md:w-32" }
const _hoisted_73 = { class: "pt-0 mt-0 text-gray-800" }
const _hoisted_74 = { class: "flex flex-wrap gap-4 py-6" }

import { onMounted, ref, watch } from "vue";
import { storeToRefs } from "pinia";

import DefaultButton from "@/components/DefaultButton.vue";
import ListRowItem from "@/components/ListRowItem.vue";
import TitleHeader from "@/components/TitleHeader.vue";
import AlertCard from "@/components/AlertCard.vue";

import api from "@/api/api";
import { useGlobalStore, useUserStore } from "@/store";

import { formatDate, getTimezoneInfo } from "@/utils/dates";
import { addMultiClubDatesUtil } from "@/utils/clubs";
import { brickClubsSettingOptions } from "@/utils/constants";


export default /*#__PURE__*/_defineComponent({
  __name: 'NewClub',
  setup(__props) {

const globalStore = useGlobalStore();

const { user, short_timezone, timezone, timezone_offset } = storeToRefs(useUserStore());
const { countries } = storeToRefs(useGlobalStore());

const isSaving = ref(false);
const isLoading = ref(false);

const settings = brickClubsSettingOptions;

const datepicker = ref(null);
const first_club_date_datepicker = ref(null);
const last_club_date_datepicker = ref(null);

const dates = ref([
  {
    end_time: "",
    date: "",
    start_time: "",
    timezone: timezone.value,
    short_timezone: short_timezone.value,
    timezone_offset: timezone_offset.value,
  },
] as { date: string; start_time: string; end_time: string; timezone: string; short_timezone: string; timezone_offset: number }[]);

const club = ref({
  owner_id: "",
  template_id: 0,
  name: "",
  address_line_one: "",
  address_line_two: "",
  city: "",
  region: "",
  postcode: "",
  country: "",
  status: "published",
  visibility: false,
  max_attendees: null,
  first_club_date: "",
  last_club_date: "",
  participants_count: 0,
  setting: "",
  min_age: 0,
  max_age: 0,
  facilitator_id: "",
  organisation_id: "",
});

const multiDates = ref({
  amount: 0,
  day: 1,
  start_time: "",
  end_time: "",
});

function setDate(date: Date, ref: string) {
  if (!date) return;

  // @ts-ignore
  club.value[ref] = formatDate(date);

  if (ref === "first_club_date") {
    // @ts-ignore
    first_club_date_datepicker.value.closeMenu();
  }

  if (ref === "last_club_date") {
    // @ts-ignore
    last_club_date_datepicker.value.closeMenu();
  }
}

function setScheduleDate(i: number, date: Date) {
  if (!date) return;

  const { short_timezone, timezone_offset } = getTimezoneInfo(date, timezone.value);

  dates.value[i] = {
    date: formatDate(date),
    start_time: dates.value[i].start_time,
    end_time: dates.value[i].end_time,
    timezone: timezone.value,
    short_timezone,
    timezone_offset,
  };

  // @ts-ignore
  datepicker.value[i].closeMenu();
}

function addClubDate() {
  dates?.value.push({
    date: "",
    start_time: "",
    end_time: "",
    timezone: timezone.value,
    short_timezone: short_timezone.value,
    timezone_offset: timezone_offset.value,
  });
}

function addMultiClubDates() {
  addMultiClubDatesUtil({
    dates,
    multiDates,
    timezone
  });
}

function removeClubDate(index: number) {
  if (index === 0) {
    return;
  }

  dates.value.splice(index, 1);
}

async function saveClub() {
  try {
    isSaving.value = true;
    const response = await api.clubs.createClub({
      ...club.value,
      dates: dates.value,
    });

    globalStore.toast("SUCCESS", "Brick Club created");
    return (window.location.href = `/dashboard/clubs/${response.data.club.id}`);
  } catch (e) {
    console.log("ERROR", e);
    globalStore.toast("ERROR", "Error creating Brick Club");
    isSaving.value = false;
  }
}

onMounted(() => {
  if (!user.value.has_brick_club_access) {
    return (window.location.href = "/dashboard");
  }

  isLoading.value = true;
  club.value.owner_id = user.value.id;
  club.value.facilitator_id = user.value.id;
  club.value.organisation_id = user.value.organisation_id.toString();

  club.value.template_id = 0;
  club.value.first_club_date = "";

  isLoading.value = false;
});

watch(
  () => club.value.first_club_date,
  () => {
    dates.value[0].date = club.value.first_club_date;
  }
);

return (_ctx: any,_cache: any) => {
  const _component_DatePicker = _resolveComponent("DatePicker")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createVNode(TitleHeader, {
        title: _ctx.$t('club-details')
      }, null, 8, ["title"])
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("form", {
        class: "mt-8",
        onSubmit: _withModifiers(saveClub, ["prevent"])
      }, [
        _createVNode(AlertCard, { type: "info" }, {
          default: _withCtx(() => [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t("club-visibility-note")), 1)
          ]),
          _: 1
        }),
        (!isLoading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(ListRowItem, {
                title: _ctx.$t('brick-club-name'),
                required: true,
                capitalize: false
              }, {
                default: _withCtx(() => [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    id: "name",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((club.value.name) = $event)),
                    placeholder: "Brick Club name",
                    class: "block w-full h-10 py-2 text-gray-900 border border-gray-600 rounded",
                    required: ""
                  }, null, 512), [
                    [_vModelText, club.value.name]
                  ]),
                  _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t("club-page-name-warning")), 1)
                ]),
                _: 1
              }, 8, ["title"]),
              _createVNode(ListRowItem, {
                title: _ctx.$t('first-club-date'),
                required: true,
                capitalize: false
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_DatePicker, {
                    ref_key: "first_club_date_datepicker",
                    ref: first_club_date_datepicker,
                    onInternalModelChange: _cache[1] || (_cache[1] = e => setDate(e, 'first_club_date')),
                    modelValue: club.value.first_club_date,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((club.value.first_club_date) = $event)),
                    required: "",
                    format: "dd/MMM/yyyy"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["title"]),
              _createVNode(ListRowItem, {
                title: _ctx.$t('last-club-date'),
                capitalize: false
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_DatePicker, {
                    ref_key: "last_club_date_datepicker",
                    ref: last_club_date_datepicker,
                    onInternalModelChange: _cache[3] || (_cache[3] = e => setDate(e, 'last_club_date')),
                    modelValue: club.value.last_club_date,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((club.value.last_club_date) = $event)),
                    "min-date": new Date(),
                    format: "dd/MMM/yyyy"
                  }, null, 8, ["modelValue", "min-date"])
                ]),
                _: 1
              }, 8, ["title"]),
              _createVNode(ListRowItem, {
                title: _ctx.$t('brick-club-contact-email'),
                required: false
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_4, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(user).directory_email_address) = $event)),
                      class: "block w-full h-10 py-2 text-gray-900 border border-gray-600 rounded",
                      disabled: ""
                    }, null, 512), [
                      [_vModelText, _unref(user).directory_email_address]
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["title"]),
              _createVNode(ListRowItem, {
                title: _ctx.$t('brick-club-website'),
                required: false
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_5, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(user).directory_website) = $event)),
                      class: "block w-full h-10 py-2 text-gray-900 border border-gray-600 rounded",
                      disabled: ""
                    }, null, 512), [
                      [_vModelText, _unref(user).directory_website]
                    ]),
                    _createElementVNode("p", {
                      innerHTML: _ctx.$t('brick-club-contact-email-helptext'),
                      class: "hyperlinked-paragraph"
                    }, null, 8, _hoisted_6),
                    _createElementVNode("p", {
                      innerHTML: _ctx.$t('brick-club-website-helptext-1'),
                      class: "hyperlinked-paragraph"
                    }, null, 8, _hoisted_7)
                  ])
                ]),
                _: 1
              }, 8, ["title"]),
              _createVNode(ListRowItem, {
                title: _ctx.$t('venue'),
                required: true,
                capitalize: false
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", null, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        id: "address-line-1",
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((club.value.address_line_one) = $event)),
                        placeholder: "Address Line 1",
                        class: "block w-full h-10 py-2 text-gray-900 border border-gray-600 rounded",
                        required: ""
                      }, null, 512), [
                        [_vModelText, club.value.address_line_one]
                      ])
                    ]),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      id: "address-line-two",
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((club.value.address_line_two) = $event)),
                      placeholder: "Address Line 2 (optional)",
                      class: "block w-full h-10 py-2 text-gray-900 border border-gray-600 rounded"
                    }, null, 512), [
                      [_vModelText, club.value.address_line_two]
                    ]),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      id: "city",
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((club.value.city) = $event)),
                      placeholder: "City",
                      class: "block w-full h-10 py-2 text-gray-900 border border-gray-600 rounded",
                      required: ""
                    }, null, 512), [
                      [_vModelText, club.value.city]
                    ]),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      id: "region",
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((club.value.region) = $event)),
                      placeholder: "State/Region",
                      class: "block w-full h-10 py-2 text-gray-900 border border-gray-600 rounded",
                      required: ""
                    }, null, 512), [
                      [_vModelText, club.value.region]
                    ]),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      id: "postcode",
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((club.value.postcode) = $event)),
                      placeholder: "Postcode",
                      class: "block w-full h-10 py-2 text-gray-900 border border-gray-600 rounded",
                      required: ""
                    }, null, 512), [
                      [_vModelText, club.value.postcode]
                    ]),
                    _createElementVNode("div", null, [
                      _withDirectives(_createElementVNode("select", {
                        id: "subscription",
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((club.value.country) = $event)),
                        class: "capitalize text-black border w-full rounded focus:outline-none focus:shadow-outline-primary font-normal transition duration-50 ease-in px-3 py-1.5 pr-8 h-10 border-gray-600",
                        required: ""
                      }, [
                        _hoisted_9,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(countries), (country) => {
                          return (_openBlock(), _createElementBlock("option", {
                            class: "capitalize",
                            value: country.name,
                            key: country.name
                          }, _toDisplayString(country.name), 9, _hoisted_10))
                        }), 128))
                      ], 512), [
                        [_vModelSelect, club.value.country]
                      ])
                    ]),
                    _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.$t("club-address-helptext")), 1)
                  ])
                ]),
                _: 1
              }, 8, ["title"]),
              _createVNode(ListRowItem, {
                title: _ctx.$t('setting'),
                required: true,
                capitalize: false
              }, {
                default: _withCtx(() => [
                  _withDirectives(_createElementVNode("select", {
                    id: "setting",
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((club.value.setting) = $event)),
                    class: "capitalize text-black border w-full rounded focus:outline-none focus:shadow-outline-primary font-normal transition duration-50 ease-in px-3 py-1.5 pr-8 h-10 border-gray-600",
                    required: ""
                  }, [
                    _hoisted_12,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(settings), (setting, index) => {
                      return (_openBlock(), _createElementBlock("option", {
                        class: "capitalize",
                        value: setting,
                        key: index
                      }, _toDisplayString(_ctx.$t(setting)), 9, _hoisted_13))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, club.value.setting]
                  ])
                ]),
                _: 1
              }, 8, ["title"]),
              _createVNode(ListRowItem, {
                title: _ctx.$t('age-range'),
                required: true,
                capitalize: false
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_14, [
                    _withDirectives(_createElementVNode("input", {
                      type: "number",
                      min: "1",
                      max: "100",
                      step: "1",
                      oninput: "this.value=(Math.ceil(this.value))",
                      id: "min_age",
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((club.value.min_age) = $event)),
                      placeholder: "Min. Age",
                      class: "block w-full h-10 py-2 text-gray-900 border border-gray-600 rounded",
                      required: ""
                    }, null, 512), [
                      [_vModelText, club.value.min_age]
                    ]),
                    _hoisted_15,
                    _withDirectives(_createElementVNode("input", {
                      type: "number",
                      min: "1",
                      max: "100",
                      step: "1",
                      oninput: "this.value=(Math.ceil(this.value))",
                      id: "max_age",
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((club.value.max_age) = $event)),
                      placeholder: "Min. Age",
                      class: "block w-full h-10 py-2 text-gray-900 border border-gray-600 rounded",
                      required: ""
                    }, null, 512), [
                      [_vModelText, club.value.max_age]
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["title"]),
              _createVNode(ListRowItem, {
                title: "Schedule",
                flex: false,
                required: true,
                capitalize: false
              }, {
                default: _withCtx(() => [
                  _createElementVNode("p", null, _toDisplayString(_ctx.$t("brick-club-schedule-helptext")), 1),
                  _createElementVNode("p", null, [
                    _createElementVNode("strong", null, _toDisplayString(_ctx.$t("first-club-date-helptext")), 1)
                  ]),
                  _createElementVNode("p", _hoisted_16, [
                    _createTextVNode(_toDisplayString(_ctx.$t("all-times-are-in-short_timezone", [_unref(short_timezone)])) + " ", 1),
                    _hoisted_17,
                    _createTextVNode(_toDisplayString(_ctx.$t("timezone-helptext")), 1)
                  ]),
                  _createElementVNode("table", _hoisted_18, [
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", _hoisted_19, [
                        _createElementVNode("th", _hoisted_20, _toDisplayString(_ctx.$t("date")), 1),
                        _createElementVNode("th", _hoisted_21, _toDisplayString(_ctx.$t("start-time")), 1),
                        _createElementVNode("th", _hoisted_22, _toDisplayString(_ctx.$t("end-time")), 1),
                        _createElementVNode("th", _hoisted_23, _toDisplayString(_ctx.$t("timezone")), 1),
                        _hoisted_24
                      ])
                    ]),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dates.value, (date, index) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          class: "border-b border-gray-400 divide-x-2 divide-gray-400 bg-play-gray",
                          key: index
                        }, [
                          _createElementVNode("td", _hoisted_25, [
                            _createVNode(_component_DatePicker, {
                              ref_for: true,
                              ref_key: "datepicker",
                              ref: datepicker,
                              format: "dd/MMM/yyyy",
                              modelValue: date.date,
                              "onUpdate:modelValue": ($event: any) => ((date.date) = $event),
                              required: "",
                              "enable-time-picker": false,
                              name: `date-${index}`,
                              onInternalModelChange: e => setScheduleDate(index, e)
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "name", "onInternalModelChange"])
                          ]),
                          _createElementVNode("td", _hoisted_26, [
                            _createVNode(_component_DatePicker, {
                              "time-picker": "",
                              modelValue: date.start_time,
                              "onUpdate:modelValue": ($event: any) => ((date.start_time) = $event),
                              name: `start-time-${index}`,
                              "model-type": "HH:mm",
                              required: ""
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "name"])
                          ]),
                          _createElementVNode("td", _hoisted_27, [
                            _createVNode(_component_DatePicker, {
                              "time-picker": "",
                              modelValue: date.end_time,
                              "onUpdate:modelValue": ($event: any) => ((date.end_time) = $event),
                              name: `end-time-${index}`,
                              "model-type": "HH:mm",
                              required: ""
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "name"])
                          ]),
                          _createElementVNode("td", _hoisted_28, [
                            _createElementVNode("p", _hoisted_29, _toDisplayString(date.short_timezone), 1)
                          ]),
                          _createElementVNode("td", _hoisted_30, [
                            (index !== 0)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  type: "button",
                                  class: "mx-2 underline text-blue",
                                  onClick: ($event: any) => (removeClubDate(index))
                                }, _toDisplayString(_ctx.$t("delete")), 9, _hoisted_31))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      }), 128))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_32, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dates.value, (date, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "flex flex-wrap border-b-2 border-gray-300 bg-play-gray",
                        key: index
                      }, [
                        _createElementVNode("div", _hoisted_33, [
                          _hoisted_34,
                          _createVNode(_component_DatePicker, {
                            required: "",
                            "enable-time-picker": false,
                            format: "dd/MMM/yyyy",
                            class: "mt-1",
                            modelValue: date.date,
                            "onUpdate:modelValue": ($event: any) => ((date.date) = $event)
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_35, [
                          _hoisted_36,
                          _createVNode(_component_DatePicker, {
                            required: "",
                            "time-picker": "",
                            modelValue: date.start_time,
                            "onUpdate:modelValue": ($event: any) => ((date.start_time) = $event),
                            class: "mt-1",
                            "model-type": "HH:mm"
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_37, [
                          _hoisted_38,
                          _createVNode(_component_DatePicker, {
                            required: "",
                            "time-picker": "",
                            modelValue: date.end_time,
                            "onUpdate:modelValue": ($event: any) => ((date.end_time) = $event),
                            class: "mt-1",
                            "model-type": "HH:mm"
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_39, [
                          _hoisted_40,
                          _createElementVNode("p", _hoisted_41, _toDisplayString(date.short_timezone), 1)
                        ]),
                        _createElementVNode("div", _hoisted_42, [
                          _createElementVNode("button", {
                            class: "mx-2 underline text-blue",
                            onClick: ($event: any) => (removeClubDate(index))
                          }, _toDisplayString(_ctx.$t("delete")), 9, _hoisted_43)
                        ])
                      ]))
                    }), 128))
                  ]),
                  _createVNode(DefaultButton, {
                    type: "primary",
                    disabled: !dates.value[dates.value.length - 1].date,
                    class: "mt-4",
                    onAction: addClubDate
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("add-another-date")), 1)
                    ]),
                    _: 1
                  }, 8, ["disabled"]),
                  _createElementVNode("div", _hoisted_44, [
                    _createElementVNode("p", null, _toDisplayString(_ctx.$t("if-your-brick-club-occurs-at-the-same-time-every-week-use-the-below-input-to-add-dates-quickly")), 1),
                    _createElementVNode("div", _hoisted_45, [
                      _createElementVNode("div", _hoisted_46, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.$t("add")), 1),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((multiDates.value.amount) = $event)),
                          placeholder: "1",
                          class: "w-32 h-10 py-2 mx-2 text-gray-900 border border-gray-600 rounded",
                          type: "number",
                          min: "0"
                        }, null, 512), [
                          [_vModelText, multiDates.value.amount]
                        ]),
                        _createElementVNode("span", null, _toDisplayString(_ctx.$t("weeks-of-sessions")), 1),
                        _withDirectives(_createElementVNode("select", {
                          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((multiDates.value.day) = $event)),
                          class: "w-32 h-10 py-2 mx-2 text-gray-900 border border-gray-600 rounded"
                        }, [
                          _createElementVNode("option", _hoisted_47, _toDisplayString(_ctx.$t("monday")), 1),
                          _createElementVNode("option", _hoisted_48, _toDisplayString(_ctx.$t("tuesday")), 1),
                          _createElementVNode("option", _hoisted_49, _toDisplayString(_ctx.$t("wednesday")), 1),
                          _createElementVNode("option", _hoisted_50, _toDisplayString(_ctx.$t("thursday")), 1),
                          _createElementVNode("option", _hoisted_51, _toDisplayString(_ctx.$t("friday")), 1),
                          _createElementVNode("option", _hoisted_52, _toDisplayString(_ctx.$t("saturday")), 1),
                          _createElementVNode("option", _hoisted_53, _toDisplayString(_ctx.$t("sunday")), 1)
                        ], 512), [
                          [_vModelSelect, multiDates.value.day]
                        ]),
                        _createElementVNode("span", null, _toDisplayString(_ctx.$t("between")), 1),
                        _createElementVNode("div", _hoisted_54, [
                          _createVNode(_component_DatePicker, {
                            "time-picker": "",
                            modelValue: multiDates.value.start_time,
                            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((multiDates.value.start_time) = $event)),
                            class: "mt-1",
                            "model-type": "HH:mm"
                          }, null, 8, ["modelValue"])
                        ]),
                        _createElementVNode("span", null, _toDisplayString(_ctx.$t("and")), 1),
                        _createElementVNode("div", _hoisted_55, [
                          _createVNode(_component_DatePicker, {
                            "time-picker": "",
                            modelValue: multiDates.value.end_time,
                            "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((multiDates.value.end_time) = $event)),
                            class: "mt-1",
                            "model-type": "HH:mm"
                          }, null, 8, ["modelValue"])
                        ])
                      ]),
                      _createVNode(DefaultButton, {
                        type: "primary",
                        class: "mt-4",
                        onAction: addMultiClubDates
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("add-multiple-dates")), 1)
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_56, [
                    _createElementVNode("p", null, _toDisplayString(_ctx.$t("if-your-brick-club-occurs-at-the-same-time-every-week-use-the-below-input-to-add-dates-quickly")), 1),
                    _createElementVNode("div", _hoisted_57, [
                      _createElementVNode("div", _hoisted_58, [
                        _createElementVNode("div", _hoisted_59, [
                          _createElementVNode("span", null, _toDisplayString(_ctx.$t("add")), 1),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((multiDates.value.amount) = $event)),
                            placeholder: "1",
                            class: "block w-full h-10 py-2 text-gray-900 border border-gray-600 rounded md:mx-2 md:w-32",
                            type: "number",
                            min: "0"
                          }, null, 512), [
                            [_vModelText, multiDates.value.amount]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_60, [
                          _createElementVNode("span", null, _toDisplayString(_ctx.$t("weeks-of-sessions")), 1),
                          _withDirectives(_createElementVNode("select", {
                            "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((multiDates.value.day) = $event)),
                            class: "w-full h-10 py-2 text-gray-900 border border-gray-600 rounded md:w-32 md:mx-2"
                          }, [
                            _createElementVNode("option", _hoisted_61, _toDisplayString(_ctx.$t("monday")), 1),
                            _createElementVNode("option", _hoisted_62, _toDisplayString(_ctx.$t("tuesday")), 1),
                            _createElementVNode("option", _hoisted_63, _toDisplayString(_ctx.$t("wednesday")), 1),
                            _createElementVNode("option", _hoisted_64, _toDisplayString(_ctx.$t("thursday")), 1),
                            _createElementVNode("option", _hoisted_65, _toDisplayString(_ctx.$t("friday")), 1),
                            _createElementVNode("option", _hoisted_66, _toDisplayString(_ctx.$t("saturday")), 1),
                            _createElementVNode("option", _hoisted_67, _toDisplayString(_ctx.$t("sunday")), 1)
                          ], 512), [
                            [_vModelSelect, multiDates.value.day]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_68, [
                          _createElementVNode("span", null, _toDisplayString(_ctx.$t("between")), 1),
                          _createElementVNode("div", _hoisted_69, [
                            _createVNode(_component_DatePicker, {
                              "time-picker": "",
                              modelValue: multiDates.value.start_time,
                              "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((multiDates.value.start_time) = $event)),
                              class: "mt-1",
                              "model-type": "HH:mm"
                            }, null, 8, ["modelValue"])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_70, [
                          _hoisted_71,
                          _createElementVNode("div", _hoisted_72, [
                            _createVNode(_component_DatePicker, {
                              "time-picker": "",
                              modelValue: multiDates.value.end_time,
                              "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((multiDates.value.end_time) = $event)),
                              class: "mt-1",
                              "model-type": "HH:mm"
                            }, null, 8, ["modelValue"])
                          ])
                        ])
                      ]),
                      _createVNode(DefaultButton, {
                        type: "primary",
                        class: "mt-4",
                        onAction: addMultiClubDates
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("add-multiple-dates")), 1)
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]),
                _: 1
              }),
              _createVNode(ListRowItem, {
                title: _ctx.$t('capacity-of-club'),
                required: true,
                capitalize: false
              }, {
                default: _withCtx(() => [
                  _withDirectives(_createElementVNode("input", {
                    type: "number",
                    min: "0",
                    step: "1",
                    "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((club.value.participants_count) = $event)),
                    class: "block w-full h-10 py-2 text-gray-900 border border-gray-600 rounded",
                    required: ""
                  }, null, 512), [
                    [_vModelText, club.value.participants_count]
                  ]),
                  _createElementVNode("p", _hoisted_73, _toDisplayString(_ctx.$t("capacity-of-club-helptext")), 1)
                ]),
                _: 1
              }, 8, ["title"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_74, [
          _createVNode(DefaultButton, {
            type: "primary",
            "is-form-submit": true,
            loading: isSaving.value,
            disabled: isSaving.value
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("submit")), 1)
            ]),
            _: 1
          }, 8, ["loading", "disabled"])
        ])
      ], 40, _hoisted_1)
    ])
  ], 64))
}
}

})